import { render, staticRenderFns } from "./news-details.vue?vue&type=template&id=0b2353fc&scoped=true&"
import script from "./news-details.vue?vue&type=script&lang=js&"
export * from "./news-details.vue?vue&type=script&lang=js&"
import style0 from "./news-details.vue?vue&type=style&index=0&id=0b2353fc&prod&lang=less&"
import style1 from "./news-details.vue?vue&type=style&index=1&id=0b2353fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2353fc",
  null
  
)

export default component.exports